"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInputValidation = void 0;
var _react = require("react");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Possible UI states for inputs:
 *
 * INACTIVE - The initial state of the input with a completely empty value, and no attempt
 * to fill it in. The label doubles as placeholder text.
 *
 * TYPING - The user focuses on the input and starts typing. The label moves above the input.
 * While the user is typing and attempting to satisfy the input's requirements,
 * the input shouldn't show any error indication.
 *
 * FINISHED - The user unfocuses/clicks out of the input, and the value satisfies all of the
 * input's conditions.
 *
 * ERROR - The user unfocuses/clicks out of the input, OR input is initialized with a value.
 * Some validation determines that the value doesn't satisfy the input's requirements,
 * so the input show an ERROR state.
 *
 * ERROR TYPING - While the user is typing to correct the error, the input should continue
 * to show the ERROR state until the value meets all the requirements. Once the value does
 * meet all requirements, the input should change to a TYPING state.
 */

var calculateError = function calculateError(_ref) {
  var _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? 'Error' : _ref$errorMessage,
    form = _ref.form,
    formFieldId = _ref.formFieldId,
    isValid = _ref.isValid;
  if (form) {
    var formError = form.getFieldError(formFieldId);
    return formError ? formError[0] : undefined;
  }
  return !isValid ? errorMessage : undefined;
};
/**
 * Hook implemented in core input components to calculate error states.
 * Since core components may be controlled by an Antd Form or used on their own,
 * the internal logic to determine states based on whether the component is paired can get complex.
 * This hook is meant to abstract that logic away and return more useful values.
 *
 * By default, Antd form provides the checked state in the `value` prop
 * so this is needed to calculate the checked state for boolean inputs such as checkboxes and toggles
 */
var useInputValidation = function useInputValidation(props) {
  var _props$data__field;
  var controlledChecked = props.checked,
    errorMessage = props.errorMessage,
    form = props.form,
    _props$isValid = props.isValid,
    isValid = _props$isValid === void 0 ? true : _props$isValid,
    value = props.value,
    alwaysShowError = props.alwaysShowError;
  // Whether the input should actually show a validation error
  // is determined by different focus states as described above
  var _useState = (0, _react.useState)(!!value || alwaysShowError),
    _useState2 = _slicedToArray(_useState, 2),
    showError = _useState2[0],
    setShowError = _useState2[1];

  // Props passed if input is paired with Ant Form
  var isPairedWithAntForm = Object.prototype.hasOwnProperty.call(props, 'data-__field');
  var formFieldId = (_props$data__field = props['data-__field']) === null || _props$data__field === void 0 ? void 0 : _props$data__field.name;
  var error = calculateError({
    errorMessage: errorMessage,
    form: form,
    formFieldId: formFieldId,
    isValid: isValid
  });

  // Prevent uncontrolled component warning by ensuring that
  // value passed to checked HTML attribute is always a boolean
  // NOTE: When paired with an AntD Form getFieldDecorator, the checked state
  // is actually passed in the `value` prop by default.
  var checked = isPairedWithAntForm ? !!value : !!controlledChecked;

  // The input should change to an ERROR state
  // only after the user is done typing
  var validateOnBlur = function validateOnBlur() {
    if (form) {
      form.validateFields([formFieldId]);
    }
    setShowError(true);
  };

  // Avoid errors from spreading props directly into HTML element
  delete props['data-__field'];
  delete props['data-__meta'];
  delete props['checked'];
  delete props['errorMessage'];
  delete props['form'];
  delete props['isValid'];
  return {
    checked: checked,
    error: showError ? error : undefined,
    formFieldId: formFieldId,
    validateOnBlur: validateOnBlur
  };
};
exports.useInputValidation = useInputValidation;